module.exports = __webpack_public_path__ + "img/success-cloud.db65f656.png";